import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: {},
};

export const lawyerSlice = createSlice({
  name: "lawyer",
  initialState,
  reducers: {
    setLawyer: (state, action) => {
      state.value = action.payload;
    },
    clearLawyer: (state) => {
      state.value = {};
    },
  },
});

export const { setLawyer, clearLawyer } = lawyerSlice.actions;
export default lawyerSlice.reducer;
